// Cancelación del vendedor desde Mis ventas; al terminar refresca las ventas y los KPIs del portal.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/errors';
import { portalSalesApi } from '@/api/services/retail-wizard/retail-wizard.client';
import { STALE_SALE_CANCEL_CODES, type CancelSaleInput } from '@/shared/patterns/CancelSale';
import { PORTAL_KEYS } from '../../api/usePortal';
import { portalSaleDetailKey } from './usePortalSaleCancellation';
import { STORE_REFUNDS_KEY } from '../../refunds/api/useStoreRefunds';

export function useCancelPortalSale() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({
            saleId,
            reason,
            equipmentVerified,
            returnConditions = [],
        }: CancelSaleInput) =>
            portalSalesApi.cancel(saleId, reason, equipmentVerified, returnConditions),
        onSuccess: () => {
            void qc.invalidateQueries({ queryKey: PORTAL_KEYS.recentSales });
            void qc.invalidateQueries({ queryKey: PORTAL_KEYS.storeSales });
            void qc.invalidateQueries({ queryKey: PORTAL_KEYS.kpis });
            void qc.invalidateQueries({ queryKey: STORE_REFUNDS_KEY });
        },
        // Un rechazo por el estado de la venta relee el detalle para que el botón se deshabilite.
        onError: (error, vars) => {
            if (error instanceof ApiError && STALE_SALE_CANCEL_CODES.has(error.code)) {
                void qc.invalidateQueries({ queryKey: portalSaleDetailKey(vars.saleId) });
            }
        },
    });
}
